/**
 * @generated SignedSource<<2eebfc613a3c94deb15a5596eac44051>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type getCheckoutChargesCurrencyDisclaimer_viewer$data = {
  readonly chargeCurrencies: ReadonlyArray<Currency | null> | null;
  readonly " $fragmentType": "getCheckoutChargesCurrencyDisclaimer_viewer";
};
export type getCheckoutChargesCurrencyDisclaimer_viewer$key = {
  readonly " $data"?: getCheckoutChargesCurrencyDisclaimer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCheckoutChargesCurrencyDisclaimer_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getCheckoutChargesCurrencyDisclaimer_viewer"
};

(node as any).hash = "f99c448d8982305e47ff11212208b1f9";

export default node;
